import { render, staticRenderFns } from "./UserFaulties.vue?vue&type=template&id=4728a9d8&"
import script from "./UserFaulties.vue?vue&type=script&lang=js&"
export * from "./UserFaulties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QToggle,QCard,QCardSection,QItemLabel,QToolbar,QToolbarTitle,QBadge,QItem,QInput,QSelect,QList,QItemSection,QIcon,QTooltip,QCardActions,QBtn,QSeparator} from 'quasar'
component.options.components = Object.assign({QToggle,QCard,QCardSection,QItemLabel,QToolbar,QToolbarTitle,QBadge,QItem,QInput,QSelect,QList,QItemSection,QIcon,QTooltip,QCardActions,QBtn,QSeparator}, component.options.components || {})
